// extracted by mini-css-extract-plugin
export default {"Avatar":"AssistantAvatar_Avatar__dfR9M"};